/* eslint-disable arrow-body-style */
import http from '@/utils/http';
import type { IRegionType, IDateTypely } from '@/pages/intelligence/types/common';

// 获取公司详情页基础信息（公司详情页）
export const fetchCompanyBasicInfo = (params: { company_id: string }): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/top',
    method: 'post',
    data: params,
    rawData: false,
  }) as Promise<any>;
};

// 获取字母公司数据
export const fetchParentAndSubsidiaryCompanies = (params: { company_id: string }): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/ParentAndSubsidiaryList',
    method: 'post',
    data: params,
    rawData: false,
  }) as Promise<any>;
};

// 获取Summary数据（公司详情页 Summary页签）
export const fetchCompanyDetailsSummarySummary = (params: {
  company_id: string;
  region_type: IRegionType;
  regions: string[];
  granularity: IDateTypely;
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/summaryV2',
    // url: '/api/v1/intelligence_pc/detail/company/summary',
    method: 'post',
    data: params,
    rawData: false,
  }) as Promise<any>;
};

// 获取About数据 （公司详情页 Summary页签）
export const fetchCompanyDetailsSummaryAbout = (params: { company_id: string }): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/about',
    method: 'post',
    data: params,
    rawData: false,
  }) as Promise<any>;
};

// 获取News数据 （公司详情页 Summary页签）
export const fetchCompanyDetailsSummaryNews = (params: { company_id: string }): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/news',
    method: 'post',
    data: params,
    rawData: false,
    // TODO: 临时屏蔽公共接口报错处理，该接口test环境修复后 需要恢复公共接口报错处理
    errorHandler: true,
  }) as Promise<any>;
};

// 获取Games数据（公司详情页 Summary页签）
export const fetchCompanyDetailsSummaryGames = (params: { company_id: string }): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/games',
    method: 'post',
    data: params,
    rawData: false,
  }) as Promise<any>;
};

export const fetchCompanyGameStatsMobileTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsMobileGamesShareTable: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/games',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsMobileGamesShareTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/games/trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsMobileCountryShareTable: (payload: any) => Promise<any> = (
  payload,
) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/market',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsMobileCountryShareTrend: (payload: any) => Promise<any> = (
  payload,
) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/market/trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsDigitalRevenueTrends: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/digitalRevenueTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsDigitalRevenueGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/games/share/digitalRevenue',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsDigitalRevenueMarkets: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/pcConsoleMarketsShare',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsPhysicalRevenueTrends: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/physicalRevenueTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsPhysicalRevenueGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/games/share/physicalRevenue',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsPCUGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/games/share/pcu',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompanyStatsMAUGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/games/share/mau',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchGamesOwned: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/gamesOwned',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchGamesOwnedGenerData: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/stats/gamesCategory',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
